'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Collapsible": "Polaris-Collapsible",
  "isFullyClosed": "Polaris-Collapsible--isFullyClosed",
  "expandOnPrint": "Polaris-Collapsible--expandOnPrint"
};

exports.default = styles;
